import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(15)} 0;
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors?.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors?.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Lecturers = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;

    @media (min-width: ${breakpoints.xs}px) {
        flex-direction: row;
    }
`;

export const Lecturer = styled.div`
    display: flex;
    flex-direction: column;
    width: 25%;
    padding: ${rem(20)} ${rem(10)};
    align-items: center;

    @media (max-width: ${breakpoints.md}px) {
        width: 33.3%;
    }

    @media (max-width: ${breakpoints.xs}px) {
        width: 100%;
    }
`;

export const LecturerImage = styled.img<{ colors?: IColors; confType?: number }>`
    width: ${rem(120)};
    height: ${rem(120)};
    border-radius: 50%;
    margin-bottom: ${rem(0)};
    ${({ confType, colors }) =>
        confType === 2 || confType === 3
            ? `border: 2px solid ${colors?.colorLink};
        &:hover {
            border-color: ${colors?.colorLine};
        }`
            : ``};
`;

export const LecturerName = styled.span<{ colors: IColors }>`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    color: ${(props) => props.colors?.colorLink};
    padding-top: ${rem(20)};
    text-align: center;
`;

export const LecturerDescription = styled.p`
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    text-align: center;
    line-height: ${rem(20)};
`;

export const LecturerLink = styled.span`
    //background: ${({ theme }) => theme.colors.conferencePrimaryLight};
    color: ${({ theme }) => theme.colors.conferencePrimary};
    font-size: ${({ theme }) => theme.fontSizes.h5};
    cursor: pointer;
`;
